// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"cf756c90","239":"39d14257","357":"27bf6bce","453":"6f3b1787","626":"fa31a8c6"}[chunkId] + ".chunk.js";
};